import BaseValidator from 'services/validations/base-validator';
import {groupObjectsByProp} from 'helpers/array-helper';

export default class MaxHittersFromOneTeamValidator extends BaseValidator {
    private maxHittersFromOneTeam: number = 0;

    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        this.maxHittersFromOneTeam = sportConfig.getConfigProp('maxHittersFromOneTeam', 0);

        if (this.isSingleTeamHittersQuantityExceeded()) {
            this.addError(`The max single team hitters is ${this.maxHittersFromOneTeam}.`);
        }
    }

    private isSingleTeamHittersQuantityExceeded(): boolean {
        const maxSingleTeamHittersInEditedLineup = this.calcMaxSingleTeamHittersInEditedLineup();

        return maxSingleTeamHittersInEditedLineup > this.maxHittersFromOneTeam;
    }

    private calcMaxSingleTeamHittersInEditedLineup(): number {
        // @ts-ignore
        const {lineupPlayers} = this.dependencies;

        const teams = groupObjectsByProp(lineupPlayers, 'team');

        let max = 0;
        Object.values(teams).map((team) => {
            const hitters = team.filter((player) => !player.isPitcher());

            if (hitters.length > max) {
                max = hitters.length;
            }
        });

        return max;
    }
}
